const s = {
  topLevels: document.getElementsByClassName('menu-item-has-children'),
}

function init() {
  if (s.topLevels.length > 0) {
    bindEvents();
  }
}

function bindEvents() {
  for (let index = 0; index < s.topLevels.length; index++) {
    const element = s.topLevels[index];
    element.addEventListener('focusin', function() {openMenu(element)});
    element.addEventListener('focusout', function() {closeMenu(element)});
  }
}

function openMenu(element) {
  element.setAttribute('aria-expanded', 'true');
}

function closeMenu(element) {
  element.setAttribute('aria-expanded', 'false');
}

export { init as default }
